import { FC, ReactElement } from 'react'

import { InfoListItem } from '@/components'
import { getPersonFullName } from '@/entities/Person/PersonHelpers'
import { BasicUser } from '@/entities/User/User'
import { trans } from '@/helpers/trans'

interface EmployeesListProps {
    employees: BasicUser[]
    className?: string
}

export const EmployeesList: FC<EmployeesListProps> = ({ employees, className = '' }): ReactElement => (
    <ul className={className}>
        <InfoListItem
            label={trans('common.coworkers')}
        >
            {employees.map(employee => (
                <div key={employee.id}>
                    {getPersonFullName(employee.person)}
                </div>
            ))}
        </InfoListItem>
    </ul>
)
